// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import * as React from 'react';
import { useUserContext } from '../../context/UserContext';
import { Box, Typography } from '../../lib/base';
import { formatTime, getID } from '../../utils';

export interface PlantingContainerData {
  readonly id: string;
  readonly planting_time: number;
  readonly extra?: string;
}

export function ChildPlantingsContainer({
  plantingsIn,
  title,
}: {
  plantingsIn: PlantingContainerData[];
  title: string;
}) {
  const { timezone } = useUserContext();
  const plantingsWithFormattedTime = plantingsIn.map((planting) => ({
    ...planting,
    formattedId: getID(planting.id),
    formattedTime: formatTime(planting.planting_time, { timezone }),
  }));
  const maxIdLength = Math.max(...plantingsWithFormattedTime.map((planting) => planting.formattedId.length));
  const maxFormattedTimeLength = Math.max(
    ...plantingsWithFormattedTime.map((planting) => planting.formattedTime.length),
  );
  return (
    <>
      <Typography>{title}</Typography>
      <Box>
        <ul>
          {plantingsWithFormattedTime.map((planting) => (
            <li key={planting.id}>
              <Typography>
                Planting {planting.formattedId.padEnd(maxIdLength, ' ')} -{' '}
                {planting.formattedTime.padEnd(maxFormattedTimeLength, ' ')}
                {planting.extra && planting.extra}
              </Typography>
            </li>
          ))}
        </ul>
      </Box>
    </>
  );
}
